import { render, staticRenderFns } from "./AddRealStateLot.vue?vue&type=template&id=2c4b86ff"
import script from "./AddRealStateLot.vue?vue&type=script&lang=js"
export * from "./AddRealStateLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports